import React, {useContext} from 'react';
import {ScrollableTabsButtonAuto } from '../../../component/tab-panel';

import {HostStateContext} from "../index";

export default function VisitorManage(props) {
    const { auth } = useContext(HostStateContext);
    const access = auth.access['VisitorManage'];
    return (
        <div className="build_contents">
            <div className="nv_contents build_contents">
                <div className="build_container">
                    <ScrollableTabsButtonAuto
                        labels={access.labels}
                    >
                        {
                            access.components.map(row => row)
                        }
                    </ScrollableTabsButtonAuto>
                </div>
            </div>
        </div>
    )
}

export function dateConvert(date: string) {
    return date ? date.replace(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2}).*$/, '$1 $2') : '';
}